const environment = window['__env'];

const get = (key: string, defaultValue: any = null) => (!!environment && !!environment[key] ? environment[key] : defaultValue);

export default {
  ...environment,
  get
};
